import React, { useEffect } from 'react'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row } from 'antd'
import { LoadingView } from 'Components/modal'
import theme from 'Components/common/Theme'
import { UserList } from './components'
import { selectMerchantPackageList } from 'Store/pos/selector'
import { selectCurrentUser } from 'Store/user/selector'
import HomePageMenu from 'Components/HomePageMenu'
import { userListAPI } from 'Store/manage-user/api'
import { UserListReq } from 'Store/manage-user/types'
import { useNavigate } from 'react-router-dom'

type Props = {} & ReduxProps

const ManageUser: React.FunctionComponent<Props> = props => {
  const { currentUser, merchantPackageList } = props
  const dispatch = useDispatch()
  let history = useNavigate()

  const onGetMerchantPackageList = (): void => {
    const req: UserListReq = {}
    dispatch(userListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetMerchantPackageList()
    }
  }, [])

  return (
    <HomePageLayout
      selected="pos"
      title={'ตั้งค่าผู้ใช้งาน'}
      showMenu={false}
      showDefaultNav={false}
      customeNav={<HomePageMenu active="manage-user" history={history} bgColor={theme.colors.primary} />}
    >
      <LoadingView isShow={merchantPackageList.event.IsLoading} />
      <Row gutter={[16, 48]}>
        <Col span={24}>
          <UserList />
        </Col>
      </Row>
    </HomePageLayout>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    merchantPackageList: selectMerchantPackageList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ManageUser)
